<template>
    <ForgotPasswordForm class="mt-12" />
</template>
<script setup lang="ts">
import ForgotPasswordForm from '~/components/organisms/ForgotPasswordForm.vue';

definePageMeta({
    layout: 'shop'
})
</script>